import axios from "axios"
import { Action } from "./actionsShared"
import { server } from "./backend-url"

export const FETCH_USER_WIDGETS_PREFIX = "FETCH_USER_WIDGETS"

export const fetchUserWidgets = () => {
  const url = "/dashboard/widgets"
  return Action.GET(FETCH_USER_WIDGETS_PREFIX, url, true)
}

export const updateUserWidgets = async (widgets) => {
  const authToken = localStorage.getItem("AuthToken")
  axios.defaults.headers.common = { Authorization: `${authToken}` }
  try {
    await axios.put(`${server}/dashboard/widgets`, { widgets })
  } catch (e) {
    console.error(e)
  }
}
